export default __webpack_public_path__ + "static/media/banner_bg_mobile_lg.33288007.svg";